import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as Common from '_common';
import * as Components from '_components';
export function PageLayoutController(props) {
    const dialogCtx = Common.useSettingsDialog();
    const overlay = Common.useOverlay();
    const language = React.useContext(Common.LanguageContext);
    const module = Common.useCurrentModule();
    const user = Common.useUser();
    const responsive = Common.useResponsive();
    const [prevContext, setPrevContext] = React.useState('');
    function canUseBig() {
        return !props.preferMinimal && responsive.lg;
    }
    function toggleLanguage() {
        const targetLanguage = language.language === 'en' ? 'cs' : 'en';
        language.setLanguage(targetLanguage);
    }
    function showAccount() {
        if (user.isPublic) {
            dialogCtx.setTab(Common.SettingsTabs.Login);
        }
        else {
            dialogCtx.setTab(Common.SettingsTabs.UserInfo);
        }
    }
    function showSettings() {
        dialogCtx.setTab(Common.SettingsTabs.Theme);
    }
    function showAbout() {
        dialogCtx.setTab(Common.SettingsTabs.About);
    }
    React.useEffect(() => {
        const context = canUseBig() + window.location.href;
        if (context !== prevContext) {
            overlay.setOverlay({ type: Common.OverlayType.Null });
            setPrevContext(context);
        }
    });
    function title() {
        if (props.title) {
            return (_jsx("h1", { children: _jsx(Components.MLT, { ...props.title }) }));
        }
        else if (module) {
            return (_jsx("h1", { children: _jsx(Components.MLT, { text: module?.name }) }));
        }
        else {
            return _jsx("h1", { children: "MichalF.cz" });
        }
    }
    function toggleMenuOverlay() {
        if (overlay.overlay.type === Common.OverlayType.Navigation) {
            overlay.setOverlay({ type: Common.OverlayType.Null });
        }
        else {
            overlay.setOverlay({ type: Common.OverlayType.Navigation });
        }
    }
    return (_jsxs(Components.Frame, { children: [_jsxs(Components.FrameComponent, { side: Components.FrameComponentType.Top, type: Components.FrameSideType.Big, children: [canUseBig() || (_jsx(Components.FrameSegment, { children: _jsx(Components.BtnGroup, { children: _jsx(Components.Button, { onClick: () => toggleMenuOverlay(), children: "Menu" }) }) })), _jsx(Components.FrameSegment, { type: Components.FrameSegmentType.Empty }), _jsx(Components.FrameSegment, { children: _jsx(Common.Placeholder, { name: "Title", children: title() }) })] }), _jsxs(Components.FrameComponent, { side: Components.FrameComponentType.Left, type: canUseBig() ? Components.FrameSideType.Big : Components.FrameSideType.None, isDecorated: false && responsive.xl, children: [_jsx(Components.FrameSegment, { type: responsive.xl
                            ? Components.FrameSegmentType.Complex
                            : Components.FrameSegmentType.Simple, children: _jsx(Components.NavSideBar, {}) }), _jsx(Components.FrameSegment, { type: Components.FrameSegmentType.Empty })] }), _jsxs(Components.FrameComponent, { side: Components.FrameComponentType.Bottom, type: Components.FrameSideType.Big, children: [_jsx(Components.FrameSegment, { children: _jsx("small", { children: _jsx(Components.VersionInfo, {}) }) }), _jsx(Common.MinimizedFrames, {}), _jsx(Components.FrameSegment, { type: Components.FrameSegmentType.Empty }), _jsx(Components.FrameSegment, { children: _jsxs(Components.BtnGroup, { children: [_jsx(Common.Placeholder, { name: "ContextButtons" }), props.widgets?.bottomButtons, _jsx(Components.Button, { onClick: showAccount, children: _jsx(Components.IconPerson, {}) }), _jsx(Components.Button, { onClick: showSettings, children: _jsx(Components.IconSettings, {}) }), _jsx(Components.Button, { onClick: toggleLanguage, children: language.language }), _jsx(Components.Button, { onClick: showAbout, children: _jsx(Components.IconInfo, {}) })] }) })] }), _jsxs(Components.FrameComponent, { side: Components.FrameComponentType.Content, children: [_jsx(Common.Notifications, {}), _jsx(React.Suspense, { children: props.children })] }), _jsx(Common.WidgetPlaceholder, { type: Common.WidgetPlaceholderType.Floating })] }));
}
